import { Tooltip, type TooltipProps } from "@mui/material";
import type { ReactElement, ReactNode } from "react";
import { mesfColors } from "@/setup/ag-grid/mesf-theme";

interface Props extends Omit<TooltipProps, "title" | "children"> {
	title: ReactNode;
	children: ReactElement<Record<string, unknown>>;
}

// Shared tooltip styling for all visualizer graphical elements.
// White background + light border + small shadow → matches the look of the
// ECharts tooltip used by the R-Factor chart. Replaces the basic browser
// `<title>` tooltip (which was slow to appear and had no styling control).
export const VisualizerTooltip = ({ title, children, ...rest }: Props) => (
	<Tooltip
		title={title}
		placement="top"
		enterDelay={120}
		leaveDelay={50}
		componentsProps={{
			tooltip: {
				sx: {
					backgroundColor: mesfColors.background.paper,
					color: mesfColors.text.primary,
					border: `1px solid ${mesfColors.grey[300]}`,
					boxShadow: 3,
					fontSize: "0.75rem",
					padding: "8px 10px",
					maxWidth: 320,
					"& .MuiTypography-root": {
						color: mesfColors.text.primary,
					},
				},
			},
		}}
		{...rest}
	>
		{children}
	</Tooltip>
);
